module.exports = __webpack_public_path__ + "resources/img/img_nginx.dbf2e1f8d38bf945a5f9d2551ed617b2.png";